import React from "react";
import { LogIn, CheckCircle2 } from "lucide-react";
import { EsBadge } from "./EsBadge";

const ddmm = (iso) => (iso ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}` : "");

export function RientriBox({ items = [], titolo = "Rientrati oggi", testid = "rientri-box", onOpen }) {
  if (!items.length) return null;
  return (
    <div className="gr-card p-5 border-l-4 border-sky-500" data-testid={testid}>
      <h2 className="font-head font-bold flex items-center gap-2 mb-1">
        <LogIn size={18} className="text-sky-600" /> {titolo}
        <span className="ml-auto text-xs font-bold rounded-full px-2.5 py-0.5 bg-sky-600 text-white tabnum" data-testid={`${testid}-count`}>{items.length}</span>
      </h2>
      <p className="text-xs text-muted-foreground mb-3">Ospiti tornati in struttura: ecco cosa resta da recuperare nel turno.</p>
      <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-3">
        {items.map((r) => (
          <div key={`${r.ospite_id}-${r.ora_rientro}`} className="rounded-xl border border-sky-200 bg-sky-50/50 p-3" data-testid={`${testid}-item-${r.ospite_id}`}>
            <button onClick={() => onOpen && onOpen(r)} className="font-semibold text-left hover:underline">{r.cognome} {r.nome}</button><EsBadge id={r.ospite_id} />
            <div className="text-xs text-sky-800 font-semibold mt-0.5">
              {r.tipo === "Ricovero" ? "Rientrato dal ricovero" : "Rientrato"}{r.ora_rientro ? ` alle ${r.ora_rientro}` : ""}
              {r.dal && <span className="font-normal text-muted-foreground"> · fuori dal {ddmm(r.dal)}{r.ora_uscita ? ` ore ${r.ora_uscita}` : ""}{r.giorni > 0 ? ` (${r.giorni} ${r.giorni === 1 ? "giorno" : "giorni"})` : ""}</span>}
            </div>
            {r.motivo && <div className="text-[11px] text-muted-foreground truncate" title={r.motivo}>{r.motivo}</div>}
            {r.da_recuperare.length === 0
              ? <div className="mt-2 text-xs font-semibold text-emerald-700 flex items-center gap-1"><CheckCircle2 size={14} /> Niente da recuperare</div>
              : <div className="mt-2 flex flex-wrap gap-1.5" data-testid={`${testid}-recupero-${r.ospite_id}`}>
                  {r.da_recuperare.map((x) => <span key={x} className="text-[11px] font-semibold rounded-full px-2 py-0.5 bg-amber-100 text-amber-800 border border-amber-200">{x}</span>)}
                </div>}
          </div>
        ))}
      </div>
    </div>
  );
}
